'use strict';

function ctrl($scope, $http, timeFormat, settings, usSpinnerService, Global, $window, $location) {
    let model = this;
    model.settings = settings;
    $scope.global = Global;
    if ($scope.global.user.user_level != "superadmin"){
        $location.url('/live');
    }
    // defaults
    model.access = {}
    model.editPane = false;
    model.formMode = false;
    model.historyShow = false;
    model.reset = function (form) {
        if (form) {
            form.$setPristine();
            form.$setUntouched();
        }
        model.user = {
            access: angular.copy(model.access)
        };
    };
    model.reset();
    // user_level dropdown labeling
    model.userLevelDisplay = function (user) {
        let level;
        if (user.user_level === 'superadmin') {
            level = 'Super Admin';
        } else if (user.user_level === 'admin') {
            level = 'Admin';
        } else {
            level = 'User';
        }
        return level;
    }

    // list users
    $http({
        method: 'GET',
        url: api+'/api/users/listusers'
    })
    .success(function (data) {
        model.users = data.users;
        // collapse the clients if it is returned in data (meaning this user is a superadmin)
        if (data.clients && _.isArray(data.clients)) {
            let c = {};
            data.clients.forEach(function (d) {
                if (!c.hasOwnProperty(d.client)) {
                    c[d.client] = {
                        sites: {},
                        map: {
                            offsetx: 0,
                            offsety: 0,
                            scale: 1
                        }
                    };
                }
                c[d.client].sites[d.keyspace] = {
                    name: d.site,
                    checked: false,
                    x : 0,
                    y : 0
                };
            })
            model.access = c;
        } else {
            //othwise just take from the user's current set
            let access = angular.copy($scope.global.user.access)
            for (let c in access) {
                for (let s in access[c].sites) {
                    access[c].sites[s] = {
                        name: access[c].sites[s],
                        checked: false,
                        x : 0,
                        y : 0
                    };
                }
                access[c].map = {
                    offsetx: 0,
                    offsety: 0,
                    scale: 1
                };
            }
            model.access = access;
        }
        // With the collapsed access definitions, lets mark the users as checked or unchecked.
        model.users.map(function (user_settings)
        {
            // Copy all available access points for the requesting user to modify.
            let global_settings = angular.copy(model.access);

            for (let user_sensor in user_settings.access)
            {
                for (let user_site in user_settings.access[user_sensor].sites)
                {
                    if (global_settings.hasOwnProperty(user_sensor))
                    {
                        // Set every one in the selected user to checked.
                        global_settings[user_sensor].sites[user_site].checked = true;
                        // Set every one in the selected user to checked.
                        if (user_settings.access[user_sensor].sites[user_site].hasOwnProperty("x"))
                        {
                            global_settings[user_sensor].sites[user_site].x = user_settings.access[user_sensor].sites[user_site].x;
                        }
                        // Set every one in the selected user to checked.
                        if (user_settings.access[user_sensor].sites[user_site].hasOwnProperty("y"))
                        {
                            global_settings[user_sensor].sites[user_site].y = user_settings.access[user_sensor].sites[user_site].y;
                        }
                    }
                }

                if (user_settings.access[user_sensor].hasOwnProperty("map") && global_settings.hasOwnProperty(user_sensor))
                {
                    global_settings[user_sensor].map = user_settings.access[user_sensor].map;
                }
            }

            user_settings.access = global_settings;

            return user_settings;
        })
    });

    // loop through user access to see if anything is checked
    model.siteNotSelected = function (user) {
        let selected = true;
        for (let i in user.access) {
            for (let s in user.access[i].sites) {
                if (user.access[i].sites[s].checked) {
                    selected = false;
                    break;
                }
            }
        }
        return selected;
    }

    // reset all modes and fields
    model.cancel = function (form) {
        model.editPane = false;
        model.formMode = false;
        model.reset(form);
    }

    // button starting the process of creating a user
    model.createUser = function () {
        model.editPane = true;
        model.formMode = 'create';
        model.reset(model.form);
        model.doneBtn = function (user, form) {
            // do nothing if the form isn't valid
            if ( form.$invalid || (model.siteNotSelected(user)) ) {
                return
            }
            $http({
                method: 'POST',
                url: api+'/api/users/create',
                data: {
                    user: user
                }
            })
            .success(function (data) {
                data.user.access = user.access
                data.user.settings_global = data.settings;
                model.users.push(data.user);
                model.cancel(form);
            })
        }
    }

    // our edit mode is set here
    model.editUser = function (user, index) {
        model.editPane = true;
        model.formMode = 'edit'
        model.user = angular.copy(user);
        model.saveBtn = function (user, form) {
            // do nothing if there isnt more than one site selected
            if ( model.siteNotSelected(user) ) {
                return
            }
            $http({
                method: 'POST',
                url: api+'/api/users/edit',
                data: {
                    user: user
                }
            })
            .success(function (token) {
                model.users[index] = user;
                model.cancel(form);
                // update the access object when editing ourselves
                if (token) {
                    // delete old token
                    delete $window.sessionStorage.token;
                    // set new token
                    $window.sessionStorage.token = token;
                    // also update available access points
                    $scope.global.user.access = user.access;
                    $scope.global.user.settings_global = user.settings_global;
                    model.access = user.access;
                }
            })
        }
    }

    model.viewHistory = function (user) {
        model.historyShow = true;
        $http({
            method: 'GET',
            url: api+'/api/users/gethistory?email='+user.email
        })
        .success(function (data) {
            for (var d=0, len = data.length; d< len; d++) {
                data[d].time = timeFormat(data[d].time, 'tables');
            }
            model.history = data;
        });
    }

    model.hideHistory = function () {
        model.historyShow = false;
        delete model.history;
    }

    // deleting users
    model.delete = function (user, index) {
        let c = confirm('Are you sure you\'d like to delete '+user.email+'???')
        if (c) {
            $http({
                method: 'POST',
                url: api+'/api/users/delete',
                data: {
                    user: user
                }
            })
            .success(function (data) {
                model.users.splice(index, 1);
            })
        }
    }
}

ctrl.$inject = ['$scope', '$http', 'timeFormat', 'settings', 'usSpinnerService', 'Global', '$window', '$location'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/users/manage_users.js
 **/